import type { FC, MouseEvent, ReactNode } from 'react'
import { useRadarNav } from './state'

export const Link: FC<{
  href: string
  children: ReactNode
  className?: string
}> = ({ href, children, className }) => {
  const { route } = useRadarNav()
  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    route(href)
  }

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}
